import store from '@/store'

export const createEntityApiDB = tableName => {
  const list = async () => await store.state.indexDB[tableName].toArray()
  const get = async ({ id }) => await store.state.indexDB[tableName].get(id)
  const add = async ({ entity }) => {
    await store.state.indexDB[tableName].add(entity)
  }
  const update = async ({ id, entity }) =>
    await store.state.indexDB[tableName].update(id, entity)
  const remove = async ({ id }) =>
    await store.state.indexDB[tableName].delete(id)
  const removeAll = async () => await store.state.indexDB[tableName].clear()

  return {
    list,
    get,
    add,
    update,
    remove,
    removeAll
  }
}
